import React from 'react';
const TextPlaceholder = ({ message }) => (React.createElement("section", { className: "tbody-empty-state" },
    React.createElement("span", null, message)));
export default TextPlaceholder;
